import { render } from "./designSelectPreview.vue?vue&type=template&id=f21cb8fe&scoped=true"
import script from "./designSelectPreview.vue?vue&type=script&lang=js"
export * from "./designSelectPreview.vue?vue&type=script&lang=js"

import "./designSelectPreview.vue?vue&type=style&index=0&id=f21cb8fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21cb8fe"]])

export default __exports__